var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    { staticClass: "navbar", attrs: { mode: "horizontal" } },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: {
          "toggle-click": _vm.toggleSideBar,
          "is-active": _vm.sidebar.opened
        }
      }),
      _vm._v(" "),
      _c("breadcrumb"),
      _vm._v(" "),
      _c(
        "el-dropdown",
        { staticClass: "avatar-container", attrs: { trigger: "click" } },
        [
          _c("div", { staticClass: "avatar-wrapper" }, [
            _vm._v("\n      " + _vm._s(_vm.name) + "\n      "),
            _c("i", { staticClass: "el-icon-caret-bottom" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "user-dropdown",
              attrs: { slot: "dropdown" },
              slot: "dropdown"
            },
            [
              _c("el-dropdown-item", [
                _c(
                  "span",
                  {
                    staticStyle: { display: "block" },
                    on: { click: _vm.gotoSystem }
                  },
                  [_vm._v("返回后台主页")]
                )
              ]),
              _vm._v(" "),
              _c("el-dropdown-item", { attrs: { divided: "" } }, [
                _c(
                  "span",
                  {
                    staticStyle: { display: "block" },
                    on: { click: _vm.logout }
                  },
                  [_vm._v("退出登录")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a49ceb22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a49ceb22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/feige/customer/components/Navbar.vue
// module id = 406
// module chunks = 75